document.addEventListener('DOMContentLoaded', function () {
  var productRoot = document.querySelector('[data-product-root]');

  if (productRoot) {
    var mainImage = productRoot.querySelector('[data-main-image]');
    var thumbButtons = productRoot.querySelectorAll('[data-image-target]');

    thumbButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.src = button.getAttribute('data-image-target') || mainImage.src;
        mainImage.alt = button.getAttribute('data-image-alt') || mainImage.alt;

        thumbButtons.forEach(function (b) {
          b.classList.remove('is-active');
        });
        button.classList.add('is-active');
      });
    });

    var qtyInput = productRoot.querySelector('[data-qty-input]');
    var qtyUp = productRoot.querySelector('[data-qty-up]');
    var qtyDown = productRoot.querySelector('[data-qty-down]');
    var optionSelectors = productRoot.querySelectorAll('[data-option-selector]');
    var variantIdSelect = productRoot.querySelector('[data-variant-id-select]');
    var priceNode = productRoot.querySelector('[data-product-price]');
    var addToCartBtn = productRoot.querySelector('.add-to-cart');

    var syncVariantFromOptions = function () {
      if (!variantIdSelect || optionSelectors.length === 0) return;

      var selected = Array.prototype.slice.call(optionSelectors).map(function (selectNode) {
        return selectNode.value;
      });

      var matchingVariant = Array.prototype.slice.call(variantIdSelect.options).find(function (opt) {
        var option1 = opt.dataset.option1 || '';
        var option2 = opt.dataset.option2 || '';
        var option3 = opt.dataset.option3 || '';

        return option1 === (selected[0] || '') && option2 === (selected[1] || '') && option3 === (selected[2] || '');
      });

      if (!matchingVariant) return;

      variantIdSelect.value = matchingVariant.value;

      if (priceNode && matchingVariant.dataset.price) {
        priceNode.textContent = '£' + matchingVariant.dataset.price;
      }

      if (addToCartBtn) {
        var isAvailable = matchingVariant.dataset.available === 'true';
        addToCartBtn.disabled = !isAvailable;
        addToCartBtn.textContent = isAvailable ? 'Add to cart' : 'Sold out';
      }
    };

    if (optionSelectors.length > 0) {
      optionSelectors.forEach(function (selectNode) {
        selectNode.addEventListener('change', syncVariantFromOptions);
      });
      syncVariantFromOptions();
    }

    if (qtyInput && qtyUp && qtyDown) {
      qtyUp.addEventListener('click', function () {
        var current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = String(current + 1);
      });

      qtyDown.addEventListener('click', function () {
        var current = parseInt(qtyInput.value || '1', 10);
        qtyInput.value = String(Math.max(1, current - 1));
      });
    }

    var nameInput = productRoot.querySelector('[data-preview-name]');
    var previewLetter = productRoot.querySelector('[data-preview-letter]');
    var previewScript = productRoot.querySelector('[data-preview-script]');

    if (nameInput && previewLetter && previewScript) {
      var updatePreview = function () {
        var text = (nameInput.value || '').trim();
        if (!text) {
          previewLetter.textContent = 'Y';
          previewScript.textContent = 'Your Name';
          return;
        }

        previewLetter.textContent = text.charAt(0).toUpperCase();
        previewScript.textContent = text;
      };

      updatePreview();
      nameInput.addEventListener('input', updatePreview);
    }
  }

  var accordions = document.querySelectorAll('[data-accordion]');
  accordions.forEach(function (accordion) {
    var detailsNodes = accordion.querySelectorAll('details');
    detailsNodes.forEach(function (node) {
      node.addEventListener('toggle', function () {
        if (!node.open) return;
        detailsNodes.forEach(function (other) {
          if (other !== node) other.open = false;
        });
      });
    });
  });
});
